/* eslint-disable no-undef */
const trimTrailingSlash = (value) =>
  value ? value.replace(/\/+$/, "") : value;

const SERVER_IP = trimTrailingSlash(
  process.env.REACT_APP_SERVER_URL || process.env.REACT_APP_API_URL
);

// STORAGE_URL debe apuntar a la raíz de /storage (no /api/storage)
// Ej:
// - SERVER: http://localhost:4000        -> STORAGE: http://localhost:4000/storage
// - SERVER: https://dominio.com/api      -> STORAGE: https://dominio.com/storage
// - SERVER: /api                         -> STORAGE: /storage
const rawStorageUrl = trimTrailingSlash(process.env.REACT_APP_STORAGE_URL);
const serverWithoutApi =
  SERVER_IP != null ? SERVER_IP.replace(/\/api\/?$/, "") : undefined;
const STORAGE_URL =
  rawStorageUrl ?? (serverWithoutApi != null ? `${serverWithoutApi}/storage` : undefined);

// Detectar si SERVER_IP ya incluye /api para evitar duplicación
const hasApiPath = SERVER_IP?.includes('/api');

export const ENV = {
  BASE_PATH: SERVER_IP,
  STORAGE_PATH: STORAGE_URL,
  BASE_API: hasApiPath ? `${SERVER_IP}/v1` : `${SERVER_IP}/api/v1`,
  API_ROUTES: {
    REGISTER: "auth/register",
    LOGIN: "auth/login",
    REFRESH_ACCESS_TOKEN: "auth/refresh",
    USER: "user",
    MENU: "menu",
    ACADEMIC_CYCLE: "academicCycle",
    ACADEMIC_CYCLE_BY_USER: "academicCycleByUser",
    COURSE: "course",
    NEWSLETTER: "newsletter",
    POST: "post",
    SUBJECT: "subject",
    WEEK: "week",
    SESSION: "session",
    SYLLABU: "syllabu",
    GRADE: "grade",
    LEVEL: "level",
    PAYMENT_CATEGORY: "paymentCategory",
    PAYMENT_CONCEPT: "paymentConcept",
    REGISTERED_PAYMENT: "registeredPayment",
    REGISTERED_PAYMENT_BY_USER: "registeredPaymentByUser",
    STUDENT: "student",
    ROLE: "role",
    PERMISSION: "permission",
    REPORT: "report",
    DOCUMENT: "document",
    INSTITUTIONAL_DOCUMENT: "institutional-documents",
    REGISTERED_DOCUMENT: "registeredDocument",
    COURSE_TEACHER: "courseTeacher",
    ANSWER: "answer",
    NOTIFICATION: "notification",
    CLASS_SCHEDULE: "attendance/class-schedule",
    ATTENDANCE: "attendance",
    AI_CHAT: "ai/chat",
    DASHBOARD: "dashboard",
    EVENT: "events",
    EVENT_CATEGORY: "event-categories",
    COMPETENCE: "competences",
    ACADEMIC_PERIOD: "academic-periods",
    PERIOD_GRADE: "period-grades",
  },
  JWT: {
    ACCESS: "access",
    REFRESH: "refresh",
  },
};

/**
 * Genera la URL completa para un asset almacenado en el servidor de storage
 * @param {string} assetPath - Ruta del asset (ej: "avatar/man.png")
 * @returns {string|null} - URL completa del asset o null si no hay path
 * 
 * Ejemplos:
 * - Dev: buildStorageUrl("avatar/man.png") -> "http://localhost:4000/storage/avatar/man.png"
 * - Prod: buildStorageUrl("avatar/man.png") -> "https://www.iepsanisidro.edu.pe/storage/avatar/man.png"
 */
export const buildStorageUrl = (assetPath) => {
  if (!assetPath) {
    return null;
  }
  
  // Si assetPath ya es una URL completa, devolverla directamente
  if (assetPath.startsWith('http://') || assetPath.startsWith('https://')) {
    return assetPath;
  }
  
  // Obtener la raíz de storage desde ENV (puede ser "" para paths relativos)
  const storageBaseUrl = ENV.STORAGE_PATH ?? ENV.BASE_PATH;
  
  if (storageBaseUrl == null) {
    console.warn('No se encontró configuración de STORAGE_PATH o BASE_PATH');
    return null;
  }
  
  // Normalizar la ruta del asset (quitar barras iniciales y duplicadas)
  let normalizedPath = assetPath.replace(/^\/+/, ''); // Quitar barras iniciales
  
  // Si la ruta ya incluye "storage/", quitarla para evitar duplicación
/*   if (normalizedPath.startsWith('storage/')) {
    normalizedPath = normalizedPath.replace(/^storage\/+/, '');
  } */
  
  const base = String(storageBaseUrl).replace(/\/+$/, "");
  const storageRoot = base.endsWith("/storage") ? base : `${base}/storage`;

  // Construir URL final
  // En dev: http://localhost:4000/storage/avatar/man.png
  // En prod: https://www.iepsanisidro.edu.pe/storage/avatar/man.png
  // En proxy: /storage/avatar/man.png
  return `${storageRoot}/${normalizedPath}`;
};
